// extracted by mini-css-extract-plugin
module.exports = {"searchVerticalRecosContainer":"gO","productsContainer":"hO","searchVerticalReco":"iO","heading":"jO"};